import React, { StrictMode, useEffect } from "react";
import routes from "./routes";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
// import {http} from './utils/http';
import useAuthStore from "./store/auth"; // import your Axios context and instance
import { useTranslation } from "react-i18next";
import { QueryClient, QueryClientProvider } from "react-query";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const router = createBrowserRouter(routes);
const queryClient = new QueryClient();

function App() {
  const { i18n } = useTranslation();

  // async function getAccount() {
  //     try {
  //         const xAuth = localStorage.getItem('x-auth');
  //         if (!xAuth) return;
  //         if (xAuth) {
  //             const parsedXAuth = JSON.parse(xAuth);
  //             const token = parsedXAuth?.state?.token;
  //             if (!token) return;
  //         }
  //         const response = await http.get("user");
  //         const {user, roles, merchant} = await response?.data;
  //         if (user) {
  //             setUserAuth({user, roles, merchant});
  //         } else {
  //             clearToken();
  //         }
  //     } catch (e) {
  //         console.error(e)
  //         clearToken();
  //     }
  // }

  // useEffect(() => {
  //     if (token && !user) getAccount()
  //     if (!token && user) clearToken()
  // }, [token, user]);
  //
  useEffect(() => {
    const dir = i18n.language === "ar" ? "rtl" : "ltr";
    document.documentElement.dir = dir;
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);
  //
  // useEffect(() => {
  //     getAccount().then(r => {
  //         //
  //     });
  // }, []);

  return (
    // <AxiosContext.Provider value={http}>
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={true}
          newestOnTop
          closeOnClick
          rtl={i18n.language === "ar"}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          className="toast-container"
          toastClassName={() =>
            "relative flex p-1 min-h-10 rounded-xl justify-between overflow-hidden cursor-pointer shadow-xl border border-slate-200/60 mb-3 bg-white"
          }
          bodyClassName={() => "flex text-sm font-medium text-slate-900 p-3"}
        />
        {/*<ReactQueryDevtools initialIsOpen={false}/>*/}
        {/*{process.env.NODE_ENV === "development" && <ReactQueryDevtools />}*/}
      </QueryClientProvider>
    </StrictMode>
    // </AxiosContext.Provider>
  );
}

export default App;
